import React from "react";
import "./SkeletonCard.css";

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-icon shimmer" />
      <div className="skeleton-line shimmer" style={{ width: "70%", margin: "12px auto 6px" }} />
      <div className="skeleton-line shimmer" style={{ width: "90%" }} />
    </div>
  );
}

export function SkeletonText({ width = "100%", height = "14px", style = {} }) {
  return <div className="skeleton-line shimmer" style={{ width, height, ...style }} />;
}

export function SkeletonPublication() {
  return (
    <div className="skeleton-pub">
      <div className="skeleton-line shimmer" style={{ width: "60%", height: "20px", marginBottom: 8 }} />
      <div className="skeleton-line shimmer" style={{ width: "30%", height: "12px", marginBottom: 12 }} />
      <div className="skeleton-line shimmer" style={{ width: "100%", marginBottom: 6 }} />
      <div className="skeleton-line shimmer" style={{ width: "85%", marginBottom: 6 }} />
      <div className="skeleton-line shimmer" style={{ width: "50%", marginBottom: 16 }} />
      <div className="skeleton-line shimmer" style={{ width: "140px", height: "32px", borderRadius: 6 }} />
    </div>
  );
}
